/* Step 7 and Step 16 */
import { ReactElement, useContext } from 'react';
import { tile, iFVSInfoDisplay } from '@interfaces/interfaces';
import gridStyles from '@pages/forms/Grid.module.scss';
import { Field, useFormikContext } from 'formik';
import { iFVSFormValues } from '@services/FVSService';
import VicFinesContext from '@pages/forms/VicFinesFormContext';
import { TileRadio, Alert } from '@components';
import styles from './RiskAndSupportDetails.module.scss';
// import FVSStep7AlertContent from '@components/Content/AlertContent/FVSStep7AlertContent';
import InfoIcon from '../../images/info.svg';

interface iFVSRiskAndSupportDetails {
  displayObject: iFVSInfoDisplay;
  currentStepNo: string;
}

function RiskAndSupportDetails({ displayObject, currentStepNo }: iFVSRiskAndSupportDetails): ReactElement {
  const { tooltips } = useContext(VicFinesContext);
  const validTitle = Object.keys(tooltips).filter((v) => v.includes('yourriskandsupportstep7modal'));
  console.log(validTitle);
  const modalContentText = tooltips[validTitle[0]];
  // const titleText = validTitle[0].substring(validTitle[0].indexOf('|'), validTitle[0].length).replaceAll('|', ' ');
  const modalContent = (): ReactElement => (
    // eslint-disable-next-line react/no-danger
    <div className={styles.accordContent} dangerouslySetInnerHTML={{ __html: modalContentText }} />
  );
  const YesValue = (): ReactElement => (
    <>
      <div>Yes</div>
    </>
  );

  const NoValue = (): ReactElement => (
    <>
      <div>No</div>
    </>
  );

  const IDoNotKnowValue = (): ReactElement => (
    <>
      <div>I don't know</div>
    </>
  );

  const TILE_DATA_1: tile[] = [
    {
      body: <YesValue />,
      value: 'true',
    },
    {
      body: <NoValue />,
      value: 'false',
    },
  ];
  const TILE_DATA_2: tile[] = [
    {
      body: <YesValue />,
      value: 'true',
    },
    {
      body: <NoValue />,
      value: 'false',
    },
    {
      body: <IDoNotKnowValue />,
      value: 'notKnown',
    },
  ];
  const { values }: { values: iFVSFormValues } = useFormikContext();
  const { pageTitle } = displayObject.pages.riskAndSupportDetails[currentStepNo];
  const { hasScaredFeelings, hasRiskAssessment, contactSpecialist, additionalText } = displayObject.pages.riskAndSupportDetails[currentStepNo].fields;
  return (
    <div className={gridStyles.form}>
      <span className="vfH2">{pageTitle}</span>
      <div className={gridStyles.gridColFull}>
        <Field name={hasScaredFeelings.formikName} title={hasScaredFeelings.title} component={TileRadio} tileData={TILE_DATA_1} orientationRow isMandatory />
      </div>
      <div className={gridStyles.gridColFull}>
        <Field name={hasRiskAssessment.formikName} title={hasRiskAssessment.title} component={TileRadio} tileData={TILE_DATA_2} orientationRow isMandatory />
      </div>
      <div className={gridStyles.gridColFull}>
        <Field name={contactSpecialist.formikName} title={contactSpecialist.title} component={TileRadio} tileData={TILE_DATA_1} orientationRow isMandatory />
        {values.ContactSpecialist === 'true' && (
        <>
          <br />
          <div>{additionalText.title}</div>
        </>
        )}
        {values.ContactSpecialist === 'true' && <Alert message={modalContent()} theme="info" icon={InfoIcon} />}
      </div>
    </div>
  );
}

export default RiskAndSupportDetails;
